import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/sharp-solid-svg-icons';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize, ButtonVariant } from '@/components/button';
import IconButton from '@/components/button/iconButton';
import Typography from '@/components/typography';

type Props = {
  title: string;
  subtitle?: string;
  count: number;
  onToggleOpen: () => void;
  isOpen: boolean;
  additionalElements?: JSX.Element;
};

export const DropdownHeader: FC<Props> = ({
  title,
  subtitle = undefined,
  count,
  isOpen,
  onToggleOpen,
  additionalElements = undefined,
}) => {
  return (
    <div className="flex w-full flex-row items-center bg-white py-3 pl-3 pr-2">
      <div className="mr-auto">
        <div className="flex flex-row gap-2">
          <Typography className="leading-[20px]" variant="h5">
            {title}
          </Typography>
          {count > 0 && (
            <Typography className="leading-[20px]" variant="body1">
              {count}
            </Typography>
          )}
        </div>
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      </div>
      {additionalElements}
      <IconButton
        size={ButtonSize.SMALL}
        variant={ButtonVariant.GHOST}
        onClick={onToggleOpen}
      >
        <FontAwesomeIcon
          className={twMerge(
            'text-gray-100 transition',
            isOpen && 'rotate-180'
          )}
          icon={faChevronDown}
        />
      </IconButton>
    </div>
  );
};
